<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="#CBD5E1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M15.506 15.313H3.553M6.366 12.5l-2.813 2.813 2.813 2.812"
    />
    <path
      stroke="#64748B"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M9.494 9.688h11.953M18.634 12.5l2.813-2.813-2.813-2.812"
    />
  </svg>
</template>
